import { render, staticRenderFns } from "./deptRetreatDetails.vue?vue&type=template&id=b8136106&scoped=true"
import script from "./deptRetreatDetails.vue?vue&type=script&lang=js"
export * from "./deptRetreatDetails.vue?vue&type=script&lang=js"
import style0 from "./deptRetreatDetails.vue?vue&type=style&index=0&id=b8136106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8136106",
  null
  
)

export default component.exports